import React, { useState } from 'react';
import Select from 'react-select';

import { confService } from '../../../Services';

import Modal from '../../Common/Modal';

import {ReactComponent as Edit} from '../../../images/icons/General/edit-01.svg';
import {ReactComponent as Plus} from '../../../images/icons/General/plus.svg';
import {ReactComponent as Loading} from '../../../images/icons/General/loading-01.svg';
import {ReactComponent as Sunset} from '../../../images/icons/Weather/sunset.svg';
import {ReactComponent as Sunrise} from '../../../images/icons/Weather/sunrise.svg';

const LocationSpecies = ({ locationId, speciesList }) => {
    const [species, setSpecies] = useState(speciesList || []);
    const [editItem, setEditItem] = useState(null);
    const [editItemKey, setEditItemKey] = useState(null);
    const [statusLoading, setStatusLoading] = useState(0);

    const feedable = {
        "1": "Volunteer Divers",
        "2": "Staff",
        "3": "Volunteer Divers and Staff"
    }

    const individual = {
        "0": "a Group (reporting percentage of population fed)",
        "1": "an Individual (reporting percentage of food consumed)",
        "2": "an Individual (reporting number of pieces of food consumed)"
    }

    const setStatus = async (id, name, statusValue) => {
        setStatusLoading(id);
        const res = await confService.locationSpeciesStatus({
            id: id,
            status: statusValue ? 1 : 0
        });

        if (res.result === 'OK')
            setSpecies(prev => {
                const newSpecies = [...prev];
                newSpecies[name] = {
                    ...newSpecies[name],
                    Active: statusValue ? 1 : 0
                };
                return newSpecies;
            });

            setStatusLoading(0);
    }

    return (
        <>                    
            <div className="bordered-content">
                <div className="header">
                    <h4>Species</h4>

                    <div className="buttons">
                        <button className="primary" type="button" onClick={() => setEditItem({})}><Plus />Add species</button>
                    </div>
                </div>  
                <table>
                    <thead>
                        <tr>
                            <th style={{width: '20%'}} >Name</th>
                            <th style={{width: '25%'}} >Fed by</th>
                            <th style={{width: '40%'}} >Fed as</th>
                            <th style={{width: '7.5%'}} >Status</th>
                            <th style={{width: '7.5%'}} >Edit</th>
                        </tr>
                    </thead>
                    <tbody>
                        {species.map((item, index) => (
                            <tr key={index} className={item.Active ? '' : 'disabled'}>
                                <td>{item.Species}</td>
                                <td>{feedable[item.FeedableBy]}</td>
                                <td>{individual[item.Individual]}</td>
                                <td className="desktop">
                                    {statusLoading === item.SpeciesID ? 
                                        <Loading className="btn-loader" /> : 
                                        (item.Active ? 
                                            <Sunset className="pointer" onClick={() => statusLoading === item.SpeciesID ? {} : setStatus(item.SpeciesID, index, !item.Active)} /> :
                                            <Sunrise className="pointer" onClick={() => statusLoading === item.SpeciesID ? {} : setStatus(item.SpeciesID, index, !item.Active)} />
                                        )
                                    }
                                </td>
                                <td><Edit onClick={() => {
                                    setEditItemKey(index);
                                    setEditItem(item);
                                }} className="pointer" /></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {editItem != null ? <ModalSpecies item={editItem} locationId={locationId} itemKey={editItemKey} setClose={() => {
                setEditItem(null);
                setEditItemKey(null);
            }} setSpecies={setSpecies} /> : ''}
        </>
    )
}

export default LocationSpecies;

const ModalSpecies = ({item, locationId, itemKey, setClose, setSpecies}) => {
    const feedable = [
        { value: '1', label: 'Volunteer Divers' },
        { value: '2', label: 'Staff' },
        { value: '3', label: 'Volunteer Divers and Staff' }
    ];

     const individual = [
        { value: '0', label: 'a Group (reporting percentage of population fed)' },
        { value: '1', label: 'an Individual (reporting percentage of food consumed)' },
        { value: '2', label: 'an Individual (reporting number of pieces of food consumed)' }
    ];

    const [data, setData] = useState(item);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [fedBy, setFedBy] = useState(item.FeedableBy ? feedable.filter(i => item.FeedableBy.toString() === i.value.toString()) : null);
    const [fedAs, setFedAs] = useState(item.SpeciesID ? individual.filter(i => i.value.toString() === item.Individual.toString()) : null);

    const customStyles = {
        container: (provided, state) => ({
            ...provided,
            flex: '1',
          }),
        control: (provided, state) => ({
          ...provided,
          border: '1px solid #D0D5DD',
          '&:hover': {
            boxShadow: '0 0 1px #5D3FC5'
          }
        })
    }

    const changeValue = (key, value) => {
        setData({
            ...data,
            [key]: value
        })
    }

     const changeSelectValue = (name, value, selectSetVar) => {
        selectSetVar(value);
        setData({
            ...data,
            [name]: value.value,
        }); 
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        
        setError('');
        setSuccess(false);
        setLoading(true);

        let message = '';

        if (!data.Species)
            message = 'Please, enter required fields';

            if (!message) {
                const res = await (data.SpeciesID ? confService.editLocationSpecies(data) : confService.addLocationSpecies({...data, LocationID: locationId}));
    
                if (res.res === 'OK') {
                    setData({...data, SpeciesID: res.id});
                    setSpecies(prev => {
                        const newSpecies = [...prev];
                        newSpecies[data.SpeciesID ? itemKey : newSpecies.length] = {
                            ...data,
                            SpeciesID: res.id,
                            Active: 1
                        };
                        return newSpecies;
                    });
                    setSuccess(true);
                } else {
                    setError(res.error);
                }
            } else {
                setError(message);
            }
            setLoading(false);
    };

    return (
        <Modal setClose={setClose} icon={<Plus />}>
            <h4>{data.SpeciesID ? 'Edit' : 'Add'} species</h4>
            <form onSubmit={handleSubmit}>
                <div className="form-control">
                    <label>Name</label>
                    <input type="text" name="Species" value={data.Species || ''} onChange={(e) => changeValue(e.target.name, e.target.value)} />
                </div>
                <div className="form-control">
                    <label>Fed by</label>
                    <Select
                        className={`select`}
                        name="FedBy"
                        onChange={(value) => changeSelectValue('FeedableBy', value, setFedBy)}
                        options={feedable}
                        styles={customStyles}
                        required
                        value={fedBy}
                    />
                </div>
                <div className="form-control">
                    <label>Fed as</label>
                    <Select
                        className={`select`}
                        name="FedAs"
                        onChange={(value) => changeSelectValue('Individual', value, setFedAs)}
                        options={individual}
                        styles={customStyles}
                        required
                        value={fedAs}
                    />
                </div>
                <div className="form-submit">
                    <div>
                        <button type="button" className="default" onClick={setClose}>Cancel</button>
                        <button type="submit" className="primary">{loading ? <Loading className="btn-loader" alt="loader" /> : ''}Save</button>
                    </div>
                    {error ? <div className="error">{error}</div> : ''}
                    {success ? <div className="success">Species was successfully {data.SpeciesID ? 'updated' : 'added'}</div> : ''}
                </div>
            </form>
        </Modal>
    )
}